import API from '.';

export default class BusinessLineReportingUnit {
  /**
   * The BLRU dimension table for UDM
   * @param {string} company_code Id of the BLRU.
   * @param {string} company_name Name of the Company.
   * @param {string} company_status_name Status of the Company.
   * @param {string} country_of_operation_code Code of the Country.
   * @param {string} functional_currency_code Code of the currency.
   * @param {number} xoM_owned_percentage Percentage of ownership.
   */
  constructor({
    company_code,
    company_name,
    //company_status_name,
    country_of_operation_code,
    //functional_currency_code,
    //xoM_owned_percentage,
  }) {
    this.company_code = company_code;
    this.company_name = company_code + ' - ' + company_name;
    //this.company_status_name = company_status_name;
    this.country_of_operation_code = country_of_operation_code;
    //this.functional_currency_code = functional_currency_code;
    //this.xoM_owned_percentage = xoM_owned_percentage;
  }

  static async getAll() {
    const api = await API();
    const { data } = await api.get('/businessLineReportingUnit');
    return data.map((d) => new BusinessLineReportingUnit(d));
  }

  static async getByCountryCode(countryCode) {
    const api = await API();
    const { data } = await api.get(
      `/businessLineReportingUnitByCountryCode/${countryCode}`
    );
    return data.map((d) => new BusinessLineReportingUnit(d));
  }

  static async getByCompanyCode(companyCode) {
    const api = await API();
    const { data } = await api.get(
      `businessLineReportingUnitByCompanyCode/${companyCode}`
    );
    return new BusinessLineReportingUnit(data);
  }
}
